import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';

import { ContentActionsService } from '~commonInfra/contentActions/ContentActions';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getDatasourceDetailInfo, openBlankWindow,replaceDatasourceIdWithConnectionIdForMixedContent } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { isIProjectItemInfo } from '../../spacesPlatform/models/resourceInfoParts';
import { NewFlowForDatasourceAction } from '../actions/NewFlowForDatasourceAction';

export function* handleNewFlowForDatasourceAction(action: NewFlowForDatasourceAction): SagaIterator {
  const newWindow: Window = openBlankWindow();
  const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
  let projectId;
  if (isIProjectItemInfo(action.contentInfo)) {
    projectId = action.contentInfo.project.id;
  }
  const mutatableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
  const datasourceDetailInfo = yield call(getDatasourceDetailInfo, mutatableContentInfo[0].id);

  newWindow.location.href = ContentActionsService.generateNewFlowUrl(siteUrlName, datasourceDetailInfo, projectId);
}
